// extracted by mini-css-extract-plugin
export default {"wrapper":"accordion_wrapper__Vg0ud","header":"accordion_header__LgaFg","footer":"accordion_footer__TKDx6","expand":"accordion_expand__A5TIF"};